var audio_rtlignore_default = {
  "fontElementMap": "ThXRV",
  "container": "ng33o",
  "customPlayer": "_7cUZp",
  "slim": "Gv-is",
  "playPauseButton": "da5Lj",
  "coverImage": "pz3Sq",
  "trackDetailsContainer": "jKLpm",
  "controlsContainer": "n95kg",
  "controlsGroup": "_9QGg5",
  "sliderContainer": "Fqrt1",
  "audioDuration": "P14mA",
  "isLoading": "wwLDq",
  "audioDetails": "IZU1o",
  "authorName": "gPcs8",
  "title": "N4-xB",
  "dropdownMenuWrapper": "Ef4-h",
  "dropdownSelectedButton": "EqAyg",
  "dropdownContent": "uP7q1",
  "dropdownContentWithIcon": "pAi-O",
  "audioLoader": "R2piU"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
